import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { GameCategoryApi, Resource, ResourceApi } from "@lbsdk/*";
import { GameApi } from "@app/shared/sdk/services/custom/Game";

@Injectable({
  providedIn: "root",
})
export class GameService implements Resolve<any> {
  games: any[] = [];
  currentGames: any[] = [];
  endedGames: any[] = [];
  onGamesChanged: BehaviorSubject<any> = new BehaviorSubject({});
  categories: any[] = [];
  onCategoriesChanged: BehaviorSubject<any> = new BehaviorSubject({});
  noOfPalyers: any;
  endedNoOfGames: any;
  currentNoOfGames: number = 0;
  onNoOfPalyersChanged: BehaviorSubject<any> = new BehaviorSubject({});
  resources: any[] = [];

  constructor(
    private gameApi: GameApi,
    private resourceApi: ResourceApi,
    private gameCategoryApi: GameCategoryApi
  ) {}

  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return new Promise<void>((resolve, reject) => {
      Promise.all([
        this.getGameCategories(),
        this.getShareAndLockIcon(),
        // this.getCurrentServerPaginationGames(),
      ]).then(() => {
        resolve();
      }, reject);
    });
  }

  getShareAndLockIcon(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.resourceApi
        .find({
          where: { or: [{ key: "privateIcon" }, { key: "shareIcon" }] },
        })
        .subscribe(
          (resources: Resource[]) => {
            this.resources = resources;
            resolve(resources);
          },
          (error) => reject(error)
        );
    });
  }

  /**
   * Get No Of Players
   * @param gameId
   * @returns {Observable<any> | Promise<any> | any}
   */

  getGameCategories(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.gameCategoryApi.find().subscribe((response: any) => {
        this.categories = response;
        this.onCategoriesChanged.next(this.categories);
        resolve(response);
      }, reject);
    });
  }

  getGames = (skip: number, limit: number, filter: any) => {
    return this.gameApi.find({
      skip: skip,
      limit: limit,
      where: filter,
      include: ["players", "category", "prizes"],
    });
  };
}
